import React from 'react';

export interface MixSegment {
  name: string;
  /** 0–1 */
  share: number;
  color: string;
}

interface MixBarProps {
  segments: readonly MixSegment[];
  /** CSS width, e.g. "5.25rem" or "100%". */
  width?: string;
  className?: string;
  id?: string;
}

/**
 * Stacked mix bar on a divider-coloured track. Segments are drawn in the order given (the fixed family order).
 * Ally Flex classes; only the sizes and colours, which come from the data, are inline.
 */
const MixBar: React.FC<MixBarProps> = ({ segments, width = '5.25rem', className, id }) => (
  <div id={id} className={`siq-mix-bar flex flex-none overflow-hidden${className ? ` ${className}` : ''}`} style={{ width, height: '.4375rem', background: 'var(--a-s-border-default)' }} aria-hidden="true">
    {segments.filter((s) => s.share > 0).map((s) => <span key={s.name} className="block h-full flex-none" style={{ width: `${Math.min(1, s.share) * 100}%`, background: s.color }} />)}
  </div>
);

export default MixBar;
